export enum DateFilterEnum {
  TODAY = 'TODAY',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_30_DAYS = 'LAST_30_DAYS',
  LIFETIME = 'LIFETIME',
  DATE_RANGE = 'DATE_RANGE',
}
